import { Link } from '@tanstack/react-router';
import { useT } from '../i18n';

export const NotFoundPage = () => {
  const { t } = useT();

  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-2 px-6 py-20 text-center">
      <p className="text-[15px] font-semibold text-ink">{t('error.pageNotFound')}</p>
      <p className="max-w-md text-[13px] text-ink-muted">{t('error.pageNotFoundHint')}</p>
      <Link
        to="/"
        className="mt-3 rounded-md bg-accent px-3.5 py-2 text-[13px] font-medium text-white hover:bg-accent-hover"
      >
        {t('error.backToDashboard')}
      </Link>
    </div>
  );
};
